export default __webpack_public_path__ + "static/group_yoga-3807fea69d65844e7e59fa761ccf64ce.jpg";